var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.286,
    height: 68.286,
    viewBox: "0 0 68.286 68.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600",
    transform: "translate(-1331 -3550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Male-Approve",
    transform: "translate(1331 3550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M28.822,2.9A1.366,1.366,0,0,1,30.76,4.828l-8.137,8.194a1.366,1.366,0,0,1-1.925.013L17.91,10.3a1.366,1.366,0,1,1,1.911-1.951l1.819,1.782Z",
    transform: "translate(30.3 4.329)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M6.366,13.165a1.366,1.366,0,0,1,0-2.731c2.625,0,4.668-1.845,4.668-4.065A1.366,1.366,0,0,1,13.6,5.711a9.643,9.643,0,0,0,8.511,4.754h14.3a1.366,1.366,0,1,1,0,2.731h-14.3a12.709,12.709,0,0,1-9.128-3.765A7.48,7.48,0,0,1,6.366,13.165Z",
    transform: "translate(8.657 8.657)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M18.764,36.337a1.378,1.378,0,0,1-.159.088l-2.079.978C9.964,40.235,5.731,46.156,5.731,52.728v3.887h38.24V52.728c0-6.587-4.253-12.52-10.838-15.343q-.913-.391-2.212-.935-.061-.025-.118-.056a15.528,15.528,0,0,1-5.952,1.115,15.475,15.475,0,0,1-6.088-1.171Zm-2.873-1.653c-4.936-3.7-7.428-10.711-7.428-19.027C8.463,6.515,14.786,2,24.851,2S41.24,6.515,41.24,15.657c0,8.325-2.5,15.341-7.445,19.04l.415.178C41.762,38.113,46.7,45,46.7,52.728v5.253a1.366,1.366,0,0,1-1.366,1.366H4.366A1.366,1.366,0,0,1,3,57.981V52.728c0-7.706,4.917-14.584,12.4-17.814l.489-.23Zm8.96.093c8.968,0,13.657-8.058,13.657-19.12,0-7.4-4.94-10.926-13.657-10.926S11.194,8.26,11.194,15.657C11.194,26.719,15.883,34.777,24.851,34.777Z",
    transform: "translate(1336.194 3553.463)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846",
    transform: "translate(-312.683 -32)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M28.822,2.9A1.366,1.366,0,0,1,30.76,4.828l-8.137,8.194a1.366,1.366,0,0,1-1.925.013L17.91,10.3a1.366,1.366,0,1,1,1.911-1.951l1.819,1.782Z",
    transform: "translate(1676.3 3589.329)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M15.891,34.684c-4.936-3.7-7.428-10.711-7.428-19.027C8.463,6.515,14.786,2,24.851,2S41.24,6.515,41.24,15.657c0,8.325-2.5,15.341-7.445,19.04l.415.178C41.762,38.113,46.7,45,46.7,52.728v5.253a1.366,1.366,0,0,1-1.366,1.366H4.366A1.366,1.366,0,0,1,3,57.981V52.728c0-7.706,4.917-14.584,12.4-17.814l.489-.23Z",
    transform: "translate(1651.193 3588.463)",
    fill: "#fe9920"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a84a0c247d72bd91fb950733e4a8228a.svg";
export { ForwardRef as ReactComponent };